/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var CarPaintProtectionType;
(function (CarPaintProtectionType) {
    CarPaintProtectionType["PpfFull"] = "PpfFull";
    CarPaintProtectionType["PpfFront"] = "PpfFront";
    CarPaintProtectionType["Coating"] = "Coating";
})(CarPaintProtectionType || (CarPaintProtectionType = {}));
export function CarPaintProtectionTypeFromJSON(json) {
    return CarPaintProtectionTypeFromJSONTyped(json, false);
}
export function CarPaintProtectionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CarPaintProtectionTypeToJSON(value) {
    return value;
}
